export default "__VITE_ASSET__Bao6cT9F__"